'use client';

import { styled } from '@linaria/react';
import MyTrackDatePicker from '@fe-news/components/molecules/MyTrackDatePicker';
import useRankingList from '@fe-news/hooks/use-ranking-list';
import { useMyTrackDate } from '@fe-news/context/my-track-date-provider';
import HotTagTrackingListSkeleton from './HotTagTrackingListSkeleton';

// type
import { RankingProductType, MyTrackSelectDate } from '@fe-news/constants/my-track/type';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';

const HotTagListContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  margin-top: 32.5px;
`;

const HotTagTitleContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.5px;
`;

const HotTagList = styled.div<{ isAside?: boolean }>`
  display: grid;
  grid-template-rows: repeat(5, 60px);
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
  grid-auto-flow: column;

  &:last-child {
    border-bottom: none;
  }

  @media screen and (max-width: ${SCREEN_SIZE.MOBILE}px) {
    grid-template-columns: repeat(1, 1fr);
    grid-auto-flow: row;
  }
`;

const RedHeadLine = styled.div`
  position: absolute;
  top: 6px;
  left: -25px;
  width: 5px;
  height: 22px;
  background-color: #e03f19;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    left: -12px;
  }
`;

type HotTagTrackingListProps = {
  renderTag: React.ComponentType<{ tag: { productId: string; cnt: number }; index: number }>;
  isRanking?: boolean;
  children: React.ReactNode;
};

const HotTagTrackingList = ({ renderTag: RenderTag, isRanking = false, children }: HotTagTrackingListProps) => {
  const { selectDate } = useMyTrackDate();
  const {
    data: rankingList,
    isError,
    errorMessage,
    isLoading
  } = useRankingList({
    type: RankingProductType.TAGS
  });

  if (isError) {
    return <div>{errorMessage}</div>;
  }

  return (
    <HotTagListContainer>
      <HotTagTitleContainer>
        <RedHeadLine />
        <h3>熱門追蹤標籤</h3>
        <MyTrackDatePicker />
      </HotTagTitleContainer>
      {selectDate === MyTrackSelectDate.RECENT_ONE_MONTH && <> {children}</>}
      {selectDate !== MyTrackSelectDate.RECENT_ONE_MONTH && isLoading && (
        <HotTagTrackingListSkeleton isRanking={isRanking} />
      )}
      {selectDate !== MyTrackSelectDate.RECENT_ONE_MONTH && !isLoading && (
        <HotTagList>
          {rankingList.map((tag, index) => (
            <RenderTag key={tag.productId} tag={tag} index={index} />
          ))}
        </HotTagList>
      )}
    </HotTagListContainer>
  );
};

export default HotTagTrackingList;
